module.exports = __webpack_public_path__ + "static/media/2007_maleRate_femaleRate.27b289f0.png";